import fetch from "./fetch";
import { handleAuthenticationResponse } from "./authenticate";
import { getStore } from "../store/createStore";
import { setSemiAuthScope } from "../store/user/actions";

export const signInSemiAuth = async (token: string, scope: string) => {
  const body = JSON.stringify({
    grant_type: "assertion",
    scope,
    provider: "ritual",
    assertion: {
      authorization: {
        code: token,
      },
    },
  });

  try {
    const response = await fetch("oauth/token", {
      method: "POST",
      credentials: "include",
      body,
      headers: {
        "Content-Type": "application/json",
      },
      fetchOptions: {
        addCastleRequestToken: true,
      },
    });

    if (response.access_token) {
      // Store the authentication response in cookies for persistence
      await handleAuthenticationResponse(response);

      getStore().dispatch(setSemiAuthScope(scope));

      return response;
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error("Semi-auth sign in failed:", error);
  }
};

export const getSemiAuthTokenAndScope = () => {
  if (typeof window === "undefined") {
    return {};
  }

  const urlSearchParams = new URLSearchParams(window.location.search);
  const token = urlSearchParams.get("token");
  const scope = urlSearchParams.get("scope");

  return {
    token,
    scope,
  };
};

export const hasSemiAuthParams = () => {
  const params = getSemiAuthTokenAndScope();
  return params.token && params.scope === "quick_manage";
};
